import { Tabs, TabsContent, TabsList, TabsTrigger } from '@hub-la/shadcn'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IntegrationProvider } from '../../../domain/dtos/integration-provider'
import { IntegrationAboutTab } from '../integration-about-tab'

type ZapierDetailProps = {
  provider: IntegrationProvider
}

export const ZapierDetail = ({ provider }: ZapierDetailProps) => {
  const { t } = useTranslation()
  const [tab, setTab] = useState('about')

  return (
    <Tabs value={tab} onValueChange={setTab}>
      <div className="w-full overflow-x-auto overflow-y-hidden border-b">
        <TabsList variant="underlined" className="border-none">
          <TabsTrigger value="about" variant="underlined">
            {t('tabs.about')}
          </TabsTrigger>
        </TabsList>
      </div>

      <TabsContent className="mt-4" value="about">
        <IntegrationAboutTab
          provider={provider}
          loading={false}
          refetch={() => {
            //
          }}
          setTab={setTab}
        />
      </TabsContent>
    </Tabs>
  )
}
